import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function TeacherRequest({ user }) {
  const [status, setStatus] = useState('pending'); // pending or submitted
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRequest = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/teachers/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: user.email,
          name: user.name
        })
      });

      if (response.ok) {
        setStatus('submitted');
      } else {
        const data = await response.json();
        alert('Error: ' + data.detail);
      }
    } catch (error) {
      alert('Error al enviar la solicitud: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>🎓 Acceso como Profesor</h1>
        
        {status === 'pending' ? (
          <div>
            <p style={styles.text}>
              Para acceder como profesor, necesitas solicitar aprobación del administrador.
            </p>
            <p style={styles.info}>
              <strong>Email:</strong> {user.email}<br />
              <strong>Nombre:</strong> {user.name}
            </p>
            <button 
              style={styles.button} 
              onClick={handleRequest}
              disabled={loading}
            >
              {loading ? '⏳ Enviando...' : '📨 Solicitar Acceso como Profesor'}
            </button>
            <button 
              style={styles.secondaryButton} 
              onClick={handleBackToLogin}
            >
              ← Volver al inicio
            </button>
          </div>
        ) : (
          <div>
            <div style={styles.success}>✅ Solicitud enviada correctamente</div>
            <p style={styles.text}>
              Tu solicitud ha sido enviada al administrador. Te notificaremos cuando sea aprobada.
            </p>
            <p style={styles.infoBox}>
              💡 Mientras tanto, puedes iniciar sesión como estudiante para explorar la plataforma.
            </p>
            <button 
              style={styles.button} 
              onClick={handleBackToLogin}
            >
              ← Volver al inicio de sesión
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
  },
  title: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '30px',
    fontSize: '28px'
  },
  text: {
    fontSize: '16px',
    color: '#555',
    lineHeight: '1.6',
    marginBottom: '20px'
  },
  info: {
    backgroundColor: '#f0f0f0',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: '14px'
  },
  infoBox: {
    backgroundColor: '#e3f2fd',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '20px',
    fontSize: '14px',
    color: '#1976d2'
  },
  button: {
    width: '100%',
    padding: '15px',
    backgroundColor: '#667eea',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginBottom: '10px',
    transition: 'all 0.3s ease'
  },
  secondaryButton: {
    width: '100%',
    padding: '15px',
    backgroundColor: '#95a5a6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  },
  success: {
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '20px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: 'bold'
  }
};

export default TeacherRequest;
